export const formDataRetriver = (form) => {
  const data = {}
  for (const md of form?.forms_metadata_by_id ?? []) {
    const field = md.field_id
    data[field] = `${
                       md.string_value ??
                       md.time_value?.split('+')[0] ??
                       md.int_value ??
                       md.date_value ??
                       md.bool_value ??
                       md.point_value ??
                       md.string_value ?? ''}`
  }

  for (const configData of form?.forms_config_lists ?? []) {
    const field = configData.field_id
    data[field] = (configData.form_config_list || []).map((item) => item.value).join(', ')
  }
  return data
}
